module.exports = __webpack_public_path__ + "img/img_5.4dcedd50.svg";